module.exports = __webpack_public_path__ + "img/img_value_01.29149ded.jpg";